export default {
  name: 'Advisory',
  data () {
      return {
        classlistThree: [
          // {id: 1, name: '19计本1班',tiaoshu: '1'},
          // {id: 2, name: '19计本2班',tiaoshu: '1'},
          // {id: 3, name: '19计本3班',tiaoshu: '4'}
        ],
        // introduce: [
        //   {id: 1, classname: '班名:', title: '19计算机科学与技术1班', projectname: '项目名', title2: 'xxxxxxxxxxx', shopname: ''}
        // ]
        MessageList: [
          {id: 1, name: '用户名', desc: 'xxxxxxxxxxxxxxxxx', day: '2019-04-19', time: '16:53', tiaoshu: '10'},
          {id: 2, name: '用户名2', desc: 'xxxxxxxxxxxxxxxxx', day: '2019-04-19', time: '16:53', tiaoshu: '44'},
          {id: 3, name: '用户名3', desc: 'xxxxxxxxxxxxxxxxx', day: '2019-04-19', time: '16:53', tiaoshu: '15'},
          {id: 4, name: '用户名4', desc: 'xxxxxxxxxxxxxxxxx', day: '2019-04-19', time: '16:53', tiaoshu: '10'},
          {id: 5, name: '用户名5', desc: 'xxxxxxxxxxxxxxxxx', day: '2019-04-19', time: '16:53', tiaoshu: ''},
        ],
        student: {
          balance: null,
          class_name: '13计算机科学与技术1班',
          class_id: 1,
          company: 'xxxxxx单位',
          email: '100317@qq.com',
          id: null,
          name: 'xxx',
          projectname: '计算机科学与技术',
          phone: '18888888888'},
          classSreach:'',
      }
  },
  methods: {
    //获取班级列表
    ClassInquiry () {
      this.$post('class/search',{token: this.$store.state.id, offset: 0, length:40 }).then(res=>{
        // // console.log("vvvvvvvv")
        // // console.log(res.data.result.data)
        // this.mobangxiangqing = res.data.result.data
        this.classlistThree = res.data.result.data
      })
    },
    //点击获取信息
    Clickdisplay2 (id,index) {
      this.id = id
      // // console.log('..........')
      // // console.log(this.id)
      // this.getstudentTwo()

      //选中变色
      if(this.$refs.light2[index].style.background==''){
        for(let i of this.$refs.light2){
          i.style.color=''
          i.style.background=''
        }
        this.$refs.light2[index].style.background='#1e87f1'
        this.$refs.light2[index].style.color='#ffffff'
      }else if(this.$refs.light[index].style.background!=''){
        this.$refs.light2[index].style.background='#1e87f1'
        this.$refs.light2[index].style.color='#ffffff'
      }else{
        this.$refs.light2[index].style.background=''
        this.$refs.light2[index].style.color=''
      }
    },

    //搜索
    toProductList () {
      // if(this.classSreach==''){
      //   return false
      // }else{
      // this.$post('class/search', { name: this.classSreach, token: this.$store.state.id, offset: 0, length: 100 }).then(res => {
      //   // console.log(res)
      //     this.classlistThree = res.data.result.data;
          
      // })
      // }
      this.$post('class/search', { name: this.classSreach, token: this.$store.state.id, offset: 0, length: 100 }).then(res => {
        // // console.log(res)
          this.classlistThree = res.data.result.data;
          
      })
    },

    //enter键搜索课程
    searchKeyDown (e) {
      if (e.key === 'Enter') {
          this.toProductList();
      }
    },

  },
  mounted() {
    this.ClassInquiry()
  }
}